import { toLower } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Fade from 'components/Fade';
import Theme from 'styles/theme';

import POSITIONS from './constants';

const Pane = ({ position, children }) => (
  <div className={`Pane Pane--${toLower(position)}`}>
    {position === POSITIONS.CENTER && <Fade show>{children}</Fade>}
    <style jsx>
      {`
        .Pane {
          transition: all ${Theme.get('transition-duration-ms')};
        }

        .Pane--${toLower(POSITIONS.CENTER)} {
          transform: translateX(0);
        }

        .Pane--${toLower(POSITIONS.LEFT)} {
          transform: translateX(-100%);
        }

        .Pane--${toLower(POSITIONS.RIGHT)} {
          transform: translateX(100%);
        }
      `}
    </style>
  </div>
);

Pane.propTypes = {
  position: PropTypes.oneOf(Object.values(POSITIONS)).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Pane;
